module.exports = __webpack_public_path__ + "static/media/managerLogo.1d749e0e.svg";